
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/[story]",
      function () {
        return require("private-next-pages/stories/[story].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/[story]"])
      });
    }
  